import React, { useEffect, useState } from 'react';
import './Pricing.css';
import { firestore, auth } from '../../firebase/firebaseConfig';
import { collection, getDocs, query, where, updateDoc, doc, addDoc, onSnapshot } from '@firebase/firestore';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/esm/Button';
import Toast from 'react-bootstrap/Toast';
import { onAuthStateChanged } from 'firebase/auth';

function Pricing ( props ) {
    let [ login, setLogin ] = useState( false );
    let [ cartCount, setCartCount ] = useState( 0 );
    let [ subTotal, setSubTotal ] = useState( 0 );
    let [ show, setShow ] = useState( false );
    let [ show2, setShow2 ] = useState( false );
    let [ addedItem, setAddedItem ] = useState( "" );
    let [ displayData, setDisplayData ] = useState( [ {
        "Wearables": [],
        "Non Wearables": []
    }, {
        "Wearables": [],
        "Non Wearables": []
    }, {
        "Men": [],
        "Women": [],
        "Kids": [],
        "Others": []
    } ] );
    let [ categoryIndex, setCategoryIndex ] = useState( 0 );
    let [ displayCategory, setDisplayCategory ] = useState( [ "Wash And Fold", "Wash And Iron", "Dry Clean" ] );

    let [ sub_categories_display, set_sub_categories_display ] = useState( [
        [ "Wearables", "Non Wearables" ],
        [ "Wearables", "Non Wearables" ],
        [ "Men", "Women", "Kids", "Others" ]
    ] );

    let sub_categories = [
        [ "wearables", "non_wearables" ],
        [ "wearables", "non_wearables" ],
        [ "men", "women", "kids", "others" ]
    ]

    async function onLoad ( user ) {
        document.querySelector( '.loader-container' ).style.display = "flex";
        let wafObject = {
            "Wearables": [],
            "Non Wearables": []
        };

        let waiObject = {
            "Wearables": [],
            "Non Wearables": []
        };

        let dcObject = {
            "Men": [],
            "Women": [],
            "Kids": [],
            "Others": []
        };

        sub_categories[ 0 ].forEach( async ( element, index ) => {
            let wash_and_fold = await getDocs( collection( firestore, "/rate_list/wash_and_fold/" + element ) );
            let displayDataArray = [];

            wash_and_fold.forEach( ( docs ) => {
                let suffix = docs.data()[ "Suffix" ];
                let displayDataObject = {};
                if ( suffix === '#' ) {
                    displayDataObject = {
                        "Category": docs.data()[ "category" ],
                        "Price": docs.data()[ "price" ],
                        "gen": "M",
                        "service": "Wash and Fold"
                    }
                } else {
                    displayDataObject = {
                        "Suffix": docs.data()[ "Suffix" ],
                        "Category": docs.data()[ "category" ],
                        "Price": docs.data()[ "price" ],
                        "gen": "M",
                        "service": "Wash and Fold"
                    }
                }
                displayDataArray.push( displayDataObject );
            } )

            wafObject[ sub_categories_display[ 0 ][ index ] ] = [ ...displayDataArray ];
            setDataWaf( wafObject );
        } )

        sub_categories[ 1 ].forEach( async ( element, index ) => {
            let wash_and_iron = await getDocs( collection( firestore, "/rate_list/wash_fold_iron/" + element ) );
            let displayDataArray = [];

            wash_and_iron.forEach( ( docs ) => {
                let suffix = docs.data()[ "Suffix" ];
                let displayDataObject = {};
                if ( suffix === '#' ) {
                    displayDataObject = {
                        "Category": docs.data()[ "category" ],
                        "Price": docs.data()[ "price" ],
                        "gen": "M",
                        "service": "Wash and Iron"
                    }
                } else {
                    displayDataObject = {
                        "Suffix": docs.data()[ "Suffix" ],
                        "Category": docs.data()[ "category" ],
                        "Price": docs.data()[ "price" ],
                        "gen": "M",
                        "service": "Wash and Iron"
                    }
                }
                displayDataArray.push( displayDataObject );
            } )
            waiObject[ sub_categories_display[ 1 ][ index ] ] = displayDataArray;
            setDataWai( waiObject );
        } )

        sub_categories[ 2 ].forEach( async ( element, index ) => {
            let dry_clean = await getDocs( collection( firestore, "/rate_list/dry_clean/" + element ) );
            let displayDataArray = [];
            let gen = "";
            if ( element === "men" ) {
                gen = "M";
            } else if ( element === "women" ) {
                gen = "W";
            } else if ( element === "kids" ) {
                gen = "K";
            }

            dry_clean.forEach( ( docs ) => {
                let suffix = docs.data()[ "Suffix" ];
                let displayDataObject = {};
                if ( suffix === '#' ) {
                    displayDataObject = {
                        "Category": docs.data()[ "category" ],
                        "Price": docs.data()[ "price" ],
                        "gen": gen,
                        "service": "Dry Clean"
                    }
                } else {
                    displayDataObject = {
                        "Suffix": docs.data()[ "Suffix" ],
                        "Category": docs.data()[ "category" ],
                        "Price": docs.data()[ "price" ],
                        "gen": gen,
                        "service": "Dry Clean"
                    }
                }
                displayDataArray.push( displayDataObject );
            } )
            dcObject[ sub_categories_display[ 2 ][ index ] ] = displayDataArray;
            setDataDc( dcObject );
        } )


        let others = await getDocs( collection( firestore, "/rate_list/others/other_items" ) );
        let index = 3;

        others.forEach( ( docs ) => {
            if ( docs.data()[ "category" ] !== "Sofa Cleaning" && docs.data()[ "category" ] !== "House Cleaning" ) {
                let suffix = docs.data()[ "Suffix" ];
                let displayDataObject = {};
                displayCategory.push( docs.data()[ "category" ] );
                setDisplayCategory( [ ...displayCategory ] );
                sub_categories_display.push( [ docs.data()[ "category" ] ] );
                set_sub_categories_display( [ ...sub_categories_display ] );
                if ( suffix === '#' ) {
                    displayDataObject = {
                        "Category": docs.data()[ "category" ],
                        "Price": docs.data()[ "price" ],
                        "gen": "",
                        "service": "Other"
                    }
                } else {
                    displayDataObject = {
                        "Suffix": docs.data()[ "Suffix" ],
                        "Category": docs.data()[ "category" ],
                        "Price": docs.data()[ "price" ],
                        "gen": "",
                        "service": "Other"
                    }
                }
                setDataOthers( { [ docs.data()[ "category" ] ]: [ displayDataObject ] }, index );
                index += 1;
            }
        } )

        if ( user ) {
            onSnapshot( collection( firestore, "users/" + user.uid + "/cart_items/all_orders_id/all_orders" ), ( snapshot ) => {
                let count = 0;
                let total = 0;
                snapshot.forEach( ( element ) => {
                    count += element.data().count;
                    total += parseFloat( element.data().price * element.data().count );
                } )
                setCartCount( count );
                setSubTotal( total.toFixed( 2 ) );
            } )
        } else {
            setCartCount( 0 );
            setSubTotal( 0 );
        }

        setTimeout( () => {
            document.querySelectorAll( ".pricing-main-head" )[ 0 ].classList.add( "active" );
            document.querySelectorAll( ".pricing-sub-head-menu" ).forEach( ( element ) => {
                element.style.display = "flex";
                element.style.display = "none";
            } )
            document.querySelectorAll( ".pricing-main-head.mobile" )[ 0 ].click();
            document.querySelectorAll( ".sub-category-open" )[ 0 ].click();
            document.querySelectorAll( ".pricing-sub-heads.mobile" )[ 0 ].childNodes[ 0 ].childNodes[ 0 ].click();
            document.querySelector( '.loader-container' ).style.display = "none";
        }, 500 )
    }

    function setDataWaf ( value ) {
        displayData[ 0 ] = value;
        setDisplayData( [ ...displayData ] );
    }

    function setDataWai ( value ) {
        displayData[ 1 ] = value;
        setDisplayData( [ ...displayData ] );
    }

    function setDataDc ( value ) {
        displayData[ 2 ] = value;
        setDisplayData( [ ...displayData ] );
    }

    function setDataOthers ( value, index ) {
        displayData[ index ] = value;
        setDisplayData( [ ...displayData ] );
    }

    function pricingHeadClick ( event, index ) {
        document.querySelectorAll( ".pricing-main-head" ).forEach( ( element ) => {
            element.classList.remove( "active" );
        } )
        setCategoryIndex( index );
        document.querySelectorAll( ".pricing-main-head" )[ index ].classList.add( "active" );
    }

    function slideDown ( event, index ) {
        let element = document.querySelectorAll( ".pricing-sub-head-menu" )[ index ];
        $( element ).slideDown();
        document.querySelectorAll( ".pricing-sub-head-menu" )[ index ].style.display = "flex";
        document.querySelectorAll( ".sub-category-open" )[ index ].style.display = "none";
        document.querySelectorAll( ".sub-category-close" )[ index ].style.display = "flex";
    }

    function slideUp ( event, index ) {
        event.stopPropagation();
        let element = document.querySelectorAll( ".pricing-sub-head-menu" )[ index ];
        $( element ).slideUp();
        document.querySelectorAll( ".sub-category-close" )[ index ].style.display = "none";
        document.querySelectorAll( ".sub-category-open" )[ index ].style.display = "flex";
    }

    function slideDownMobile ( event, index, index1 ) {
        console.log( document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ].childNodes[ index1 ].childNodes[ 1 ] );
        let element1 = document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ].childNodes[ index1 ].childNodes[ 1 ];
        $( element1 ).slideDown();
        document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ].childNodes[ index1 ].childNodes[ 1 ].style.display = "flex";
        document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ].childNodes[ index1 ].childNodes[ 0 ].childNodes[ 1 ].style.display = "none";
        document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ].childNodes[ index1 ].childNodes[ 0 ].childNodes[ 2 ].style.display = "flex";
    }

    function slideUpMobile ( event, index, index1 ) {
        event.stopPropagation();
        let element1 = document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ].childNodes[ index1 ].childNodes[ 1 ];
        $( element1 ).slideUp();
        document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ].childNodes[ index1 ].childNodes[ 0 ].childNodes[ 2 ].style.display = "none";
        document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ].childNodes[ index1 ].childNodes[ 0 ].childNodes[ 1 ].style.display = "flex";
    }

    function slideToggle ( event, index ) {
        event.stopPropagation();
        let element = document.querySelectorAll( ".pricing-sub-heads.mobile" )[ index ];
        $( element ).slideToggle();
        if ( document.querySelectorAll( ".faq-arrow-pricing svg" )[ index ].style.transform === "rotate(180deg)" ) {
            document.querySelectorAll( ".faq-arrow-pricing svg" )[ index ].style.transform = "rotate(0deg)";
        } else {
            document.querySelectorAll( ".faq-arrow-pricing svg" )[ index ].style.transform = "rotate(180deg)";
        }
    }

    // function orderFormSubmit ( event ) {
    //     event.preventDefault();
    //     let name = event.target.name.value;
    //     let phone = event.target.phone.value;
    //     let email = event.target.email.value;
    //     let address = event.target.address.value;
    //     props.settingDetails( {
    //         name: name,
    //         phone: phone,
    //         email: email,
    //         address: address
    //     } );
    //     document.getElementById( "form-button-click" ).click();
    // }

    async function itemSelect ( event, name, price, suffix, service, gen ) {
        event.stopPropagation();
        event.preventDefault();
        if ( login === true ) {
            let docs = await getDocs( query( collection( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders" ), where( "service", "==", service ), where( "gen", "==", gen ), where( "category", "==", name ) ) );
            if ( docs.empty ) {
                await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders" ), {
                    Suffix: suffix !== undefined ? suffix : "#",
                    category: name,
                    count: 1,
                    gen: gen,
                    isAdded: true,
                    price: price,
                    service: service
                } )
            } else {
                docs.forEach( async ( element ) => {
                    await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/cart_items/all_orders_id/all_orders", element.id ), {
                        count: element.data().count + 1
                    } )
                } )
            }
            setAddedItem( service + " " + name );
            setShow( true );
        } else {
            setShow2( true );
            setTimeout( () => {
                window.location.href = "/login";
            }, 3000 );
        }
    }

    useEffect( () => {
        document.title = "Laundry Buddy - Pricing | Most Affordable Laundry";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        setLogin( true );
                        props.settingDetails( {
                            name: snapshot.data().name,
                            phone: snapshot.data().mobile,
                            email: snapshot.data().email,
                            address: snapshot.data().address,
                            pincode: snapshot.data().pincode
                        } )
                        onLoad( user );
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            } else {
                onLoad();
            }
        } )
        window.scrollTo( 0, 0 );
    }, [] );

    return (
        <div className='pricing-container'>
            <Toast style={{ position: "fixed", top: "1rem", zIndex: "111111" }} position="top-center" className='rounded me-2' onClose={() => setShow( false )} show={show} delay={3000} autohide>
                <Toast.Header style={{ backgroundColor: "#117381", color: "white" }}>
                    <img
                        src={require( "../../images/logo.webp" )}
                        className="rounded me-2"
                        alt=""
                        height={30}
                    />
                    <strong className="me-auto">Item Added</strong>
                </Toast.Header>
                <Toast.Body style={{ backgroundColor: "#97C5C9", color: "white" }}>{addedItem} successfully added to the Cart.</Toast.Body>
            </Toast>
            <Toast style={{ position: "fixed", top: "1rem", zIndex: "111111" }} position="top-center" className='rounded me-2' onClose={() => setShow2( false )} show={show2} delay={3000} autohide>
                <Toast.Header style={{ backgroundColor: "#117381", color: "white" }}>
                    <img
                        src={require( "../../images/logo.webp" )}
                        className="rounded me-2"
                        alt=""
                        height={30}
                    />
                    <strong className="me-auto">User Not Logged In</strong>
                </Toast.Header>
                <Toast.Body style={{ backgroundColor: "#97C5C9", color: "white" }}>Kindly Login In to continue. You will redirected in 3 seconds.</Toast.Body>
            </Toast>
            <h4 style={{ fontWeight: "700", color: "grey" }}>Pricing</h4>
            <h1 style={{ fontWeight: "700" }}>Check Out Our Pricing</h1>
            <h6 style={{ fontWeight: "700", color: "grey" }}>Select Items to Add To Cart</h6>
            <div className='pricing-inner-container laptop'>
                <div className='pricing-main-heads'>
                    {displayCategory.map( ( element, index ) => (
                        <div className='pricing-main-head' onClick={event => pricingHeadClick( event, index )}>
                            {element}
                        </div>
                    ) )}
                </div>
                <div className='pricing-sub-heads'>
                    {sub_categories_display[ categoryIndex ].map( ( element, index ) => (
                        <div>
                            <div onClick={event => slideDown( event, index )}>
                                <span>
                                    {element}
                                </span>
                                <span className='sub-category-open'>
                                    +
                                </span>
                                <span className='sub-category-close' onClick={event => slideUp( event, index )}>
                                    -
                                </span>
                            </div>
                            <div className='pricing-sub-head-menu'>
                                <div>
                                    {( displayData[ categoryIndex ][ element ] ? displayData[ categoryIndex ][ element ] : [] ).map( ( element1 ) => (
                                        <div className='item-container' onClick={event => itemSelect( event, element1.Category, element1.Price, element1.Suffix, element1.service, element1.gen )} title="Click to Add">
                                            <span className='span'>
                                                {element1.Category}
                                            </span>
                                            <span className='span'>
                                                Rs. {element1.Price}{element1.Suffix}
                                            </span>
                                        </div>
                                    ) )}
                                </div>
                            </div>
                        </div>
                    ) )}
                </div>
            </div>
            <div className='pricing-inner-container mobile'>
                <div className='pricing-main-heads mobile'>
                    {displayCategory.map( ( element, index ) => (
                        <div className='pricing-main-div-mobile'>
                            <div className='pricing-main-head mobile' onClick={event => slideToggle( event, index )}>
                                <span>{element}</span>
                                <span className='faq-arrow-pricing'>
                                    <svg width="16" height="10" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.64331L9 9.64331L17 1.64331" stroke="#444444" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className='pricing-sub-heads mobile'>
                                {sub_categories_display[ index ].map( ( element1, index1 ) => (
                                    <div>
                                        <div onClick={event => slideDownMobile( event, index, index1 )}>
                                            <span>
                                                {element1}
                                            </span>
                                            <span className='sub-category-open mobile'>
                                                +
                                            </span>
                                            <span className='sub-category-close mobile' onClick={event => slideUpMobile( event, index, index1 )}>
                                                -
                                            </span>
                                        </div>
                                        <div className='pricing-sub-head-menu mobile'>
                                            <div>
                                                {( displayData[ index ][ element1 ] ? displayData[ index ][ element1 ] : [] ).map( ( element1 ) => (
                                                    <div className='item-container' onClick={event => itemSelect( event, element1.Category, element1.Price, element1.Suffix, element1.service, element1.gen )} title="Click to Add">
                                                        <span className='span'>
                                                            {element1.Category}
                                                        </span>
                                                        <span className='span'>
                                                            Rs. {element1.Price}{element1.Suffix}
                                                        </span>
                                                    </div>
                                                ) )}
                                            </div>
                                        </div>
                                    </div>
                                ) )}
                            </div>
                        </div>
                    ) )}
                </div>
            </div>
            <div className='cart-info-container'>
                <div>
                    <div>
                        {cartCount} Items
                    </div>
                    <div>
                        Rs. {subTotal}
                    </div>
                </div>
                <Link to="/cart">
                    <span>View Cart</span>
                    <svg width="16" height="20" viewBox="0 0 25 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25 15.1433L0 30.1433L0 0.143311L25 15.1433Z" fill="white" />
                    </svg>
                </Link>
            </div>
            <a href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/download-app-banner.webp" )} className='download-app-banner laptop' alt="" /></a>
            <a href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-mobile.webp" )} className='download-app-banner mobile' alt="" /></a>
            {/* {login === false && <div className='booking-container-info'>
                <div>
                    <img src={require( "../../images/registration-image-1.webp" )} className='laptop' alt="" />
                    <img src={require( "../../images/registration-image-mobile.webp" )} className='mobile' alt="" />
                </div>
                <div>
                    <form onSubmit={event => orderFormSubmit( event )}>
                        <div className='form-container'>
                            <div className='form-input-container'>
                                <div className='form-input-head'>
                                    Name
                                </div>
                                <div className='form-input'>
                                    <input type="text" placeholder='Enter Your Name' name="name" required autoFocus />
                                </div>
                            </div>
                            <div className='form-input-container'>
                                <div className='form-input-head'>
                                    Phone Number
                                </div>
                                <div className='form-input'>
                                    <input type="tel" placeholder='Enter Your Phone Number' name="phone" minLength={10} maxLength={10} required />
                                </div>
                            </div>
                            <div className='form-input-container'>
                                <div className='form-input-head'>
                                    Address
                                </div>
                                <div className='form-input'>
                                    <input type="text" placeholder='Enter Your Address' name="address" required />
                                </div>
                            </div>
                            <div className='form-input-container'>
                                <div className='form-input-head'>
                                    Email Id
                                </div>
                                <div className='form-input'>
                                    <input type="email" placeholder='Enter Your Email Id' name="email" required />
                                </div>
                            </div>
                        </div>
                        <Button type="submit">Schedule Free Pick Up</Button>
                        <Button style={{ display: "none" }} ><Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}>Schedule Free Pick Up</Link></Button>
                    </form>
                </div>
            </div>} */}
        </div>
    )
}

export default Pricing